<template>
    <div
        :class="[
            'web-news-stock-news-list',
            {
                isPC: isPC
            }
        ]"
    >
        <div v-if="isPreRender" key="hideContent"></div>
        <div v-else-if="loading" class="loading">
            <img src="../images/loading.png" alt="loading..." />
        </div>
        <div v-else-if="showContent" key="showContent" class="content-wrapper">
            <div class="web-news-stock-news-list-content">
                <a
                    v-for="(item, index) in showCountList"
                    :key="index"
                    class="item"
                    href="javascript:;"
                    @click="onClickItem(item)"
                >
                    <div class="title-source">
                        <div class="title" :style="{ color: titleColor }">{{ item.title }}</div>
                        <div class="source" :style="{ color: sourceColor }">
                            {{ item.source }}&nbsp;&nbsp;{{ formatTime(item.time) }}
                        </div>
                    </div>
                    <div class="img-wrapper">
                        <img :src="item.pic" />
                    </div>
                </a>
            </div>
            <div class="btn" v-if="showBtn">
                <a
                    :class="[
                        'more-text',
                        {
                            isMoo: isMoo
                        }
                    ]"
                    :style="{
                        '--more-color': moreColor
                    }"
                    href="javascript:;"
                    @click="onClickMore"
                >
                    {{ moreText }}
                    <svg width="11" height="19" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2.25 2L9.75 9.5L2.25 17"
                            stroke-width="2"
                            stroke-linecap="square"
                            stroke-linejoin="round"
                        />
                    </svg>
                </a>
            </div>
        </div>
    </div>
</template>
<script >
import { ref, computed, onMounted, getCurrentInstance } from 'vue-demi';
import { ToolDateFormatter, TEMPLATE_YMD, TEMPLATE_HMS } from '@futuweb/tool-date-formatter';
import { isMoo as isMooUtil, getEntity } from '../utils';
import { LANG_NUM_MAP } from '../constants/i18n';
import { NEWS_TYPE, isStockNewsType, isCustomNewsType } from '../constants';
import { useRenderNews } from './useRenderNews';
const __sfc_main = {};
__sfc_main.props = {
  language: {
    type: String,
    default: 'en-us'
  },
  titleColor: {
    type: String,
    default: '#262626'
  },
  sourceColor: {
    type: String,
    default: '#7a7a7a'
  },
  // 展示条数
  showCount: {
    type: Number,
    default: 3
  },
  // 查看更多
  moreText: {
    type: String,
    default: 'More'
  },
  moreColor: {
    type: String,
    default: '#327FFF'
  },
  needLogin: {
    type: Boolean,
    default: true
  },
  showBtn: {
    type: Boolean,
    default: true
  },
  stockId: {
    type: String
  },
  stockCode: {
    type: String
  },
  newsType: {
    type: Number,
    default: NEWS_TYPE.MARKET
  },
  customList: {
    type: Array,
    default: () => [{
      url: ''
    }]
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    common: {
      behavior: {
        runBehaviour
      }
    }
  } = require('@futuweb/fego-render');
  const {
    usePageType,
    useEnv
  } = require('@fegobull/webapi').use;
  const {
    isPC
  } = usePageType();
  const {
    isPreRender
  } = useEnv();
  const props = __props;
  const toolDateFormatter = new ToolDateFormatter({
    entity: getEntity()
  });
  const loading = ref(false);
  const list = ref([]);
  const isMoo = isMooUtil();
  const {
    proxy: currentInstanceProxy
  } = getCurrentInstance();
  const showContent = computed(() => {
    return !loading.value && list.value && list.value.length;
  });
  const showCountList = computed(() => {
    return isCustomNewsType(props.newsType) ? list.value : list.value.slice(0, props.showCount);
  });
  function formatTime(time) {
    return toolDateFormatter.dateFormatByTemplate({
      dateTemplateArr: [TEMPLATE_YMD.MONTH_DAY, TEMPLATE_HMS.HOUR_MINUTE],
      timestamps: time * 1e3,
      lang: LANG_NUM_MAP[props.language]
    });
  }
  function onClickItem(item) {
    const url = item.url;
    if (props.needLogin) {
      return runBehaviour(currentInstanceProxy, {
        type: 'login',
        value: url,
        lang: props.language,
        withQuery: true
      });
    }
    return location.href = url;
  }
  function onClickMore() {
    let url = '';
    if (isStockNewsType(props.newsType)) {
      url = isMoo ? `https://www.moomoo.com/stock/${props.stockCode}/news?lang=${props.language}` : `https://www.futunn.com/stock/${props.stockCode}/news?lang=${props.language}`;
    } else {
      url = isMoo ? `https://www.moomoo.com/news/main?lang=${props.language}` : `https://news.futunn.com/main?lang=${props.language}`;
    }
    if (props.needLogin) {
      return runBehaviour(currentInstanceProxy, {
        type: 'login',
        value: url,
        lang: props.language,
        withQuery: true
      });
    }
    return location.href = url;
  }
  const {
    getListData
  } = useRenderNews(props);
  onMounted(async () => {
    if (isPreRender) {
      return;
    }
    loading.value = true;
    try {
      list.value = await getListData()[props.newsType]();
    } catch (error) {
      list.value = []; // 不展示
    }
    loading.value = false;
  });
  return {
    isPC,
    isPreRender,
    loading,
    isMoo,
    showContent,
    showCountList,
    formatTime,
    onClickItem,
    onClickMore
  };
};
export default __sfc_main;
</script>
<style lang="less" scoped>
.web-news-stock-news-list {
    height: auto !important;
    &.ja {
        .web-news-stock-news-list-content {
            .item {
                .title-source {
                    .title {
                        font-family: 700;
                    }
                }
            }
        }
    }
    .web-news-stock-news-list-content {
        padding: 0 0.4rem;
        .item {
            display: flex;
            align-items: center;
            padding: 0.3rem 0;
            position: relative;
            a {
                position: absolute;
                display: block;
                width: 100%;
                height: 100%;
            }
            &:first-child {
                padding-top: 0;
            }
            &:last-child {
                padding-bottom: 0;
            }
            &:not(:last-child) {
                border-bottom: 1px solid #e5e5e5;
            }
            .title-source {
                flex: 1;
                min-width: 0;
                margin-right: 0.3rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                height: 1.4rem;
                .title {
                    font-size: 0.3rem;
                    line-height: 1.5;
                    // 限制两行
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                }
                .source {
                    font-size: 0.22rem;
                }
            }
            .img-wrapper {
                width: 1.8rem;
                height: 1.4rem;
                img {
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                    border-radius: 0.06rem;
                }
            }
        }
    }
    .content-wrapper {
        position: relative;
        .btn {
            display: flex;
            justify-content: center;
            margin-top: 0.3rem;
            .more-text {
                font-size: 0.3rem;
                line-height: 0.3rem;
                color: var(--more-color);
                display: flex;
                align-items: center;
                svg {
                    margin-left: 0.12rem;
                    width: 0.15rem;
                    height: 0.26rem;
                    path {
                        stroke: var(--more-color);
                    }
                }
            }
        }
    }
    .loading {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 2rem;
        @keyframes rotate {
            0% {
                transform: rotate(0);
            }
            100% {
                transform: rotate(360deg);
            }
        }
        img {
            width: 0.56rem;
            height: 0.56rem;
            background: url('../images/loading.png') center / contain no-repeat;
            animation: rotate 2s linear infinite;
        }
    }
}
.web-news-stock-news-list.isPC {
    .content-wrapper {
        margin: auto;
        .btn {
            .more-text {
                font-size: 0.22rem;
            }
        }
    }
    .web-news-stock-news-list-content {
        padding: 0 0 0.4rem;
        .item {
            cursor: pointer;
            .title-source {
                height: 1.6rem;
                margin-right: 0.4rem;
                .title {
                    font-size: 0.22rem;
                }
                .source {
                    font-size: 0.16rem;
                }
            }
            .img-wrapper {
                width: 2.4rem;
                height: 1.6rem;
            }
        }
    }
    .loading {
        height: 3rem;
    }
}
</style>
